import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MyDatePickerModule } from 'mydatepicker';
import { BlockUIModule } from 'ng-block-ui';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { PagingModule } from '../../components/common/search/paging.module';
import { TermsAndConditionsModalModule } from '../../components/common/terms.and.conditions.modal/t.and.c.modal.module';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { TenderTeamMemberModule } from '../tender.team.members/tender.team.member.module';
import { AccountDetailsComponent } from './account.details.component';
import { AddExtraAlertComponent } from './add.extra.alert.component';
import { BidManagementComponent } from './bid.management.component';
import { BookConsultationComponent } from './book.consultation.component';
import { CommunicationPreferencesComponent } from './communication.preferences.component';
import { EditExtraAlertComponent } from './edit.extra.alert.component';
import { ExtraAlertsListComponent } from './extra.alerts.list.component';
import { HelpPlaceholderComponent } from './help/help.placeholder.component';
import { HelpShellComponent } from './help/help.shell.component';
import { HelpAwardsComponent } from './help/help.awards.component';
import { HelpBidManagementComponent } from './help/help.bid-management.component';
import { HelpBookDemoComponent } from './help/help.book-demo.component';
import { HelpContactUsComponent } from './help/help.contact-us.component';
import { HelpFaqComponent } from './help/help.faq.component';
import { HelpTrainingComponent } from './help/help.training.component';
import { HelpTenderAlertsProfileComponent } from './help/help.tender-alerts-profile.component';
import { HelpTeamMembersComponent } from './help/help.team-members.component';
import { HelpTendersComponent } from './help/help.tenders.component';
import { QuestionnaireComponent } from './questionnaire.component';
import { SubscriptionsComponent } from './subscriptions.component';
import { TenderAlertProfileComponent } from './tender.alert.profile.component';
import { ViewAccountComponent } from './view.account.component';

@NgModule({
    declarations: [SubscriptionsComponent, BidManagementComponent, TenderAlertProfileComponent, CommunicationPreferencesComponent,
        AccountDetailsComponent, ViewAccountComponent, AddExtraAlertComponent, EditExtraAlertComponent, ExtraAlertsListComponent,
        BookConsultationComponent, HelpShellComponent, HelpTendersComponent, HelpAwardsComponent, HelpBidManagementComponent, HelpBookDemoComponent, HelpContactUsComponent, HelpFaqComponent, HelpTrainingComponent, HelpTenderAlertsProfileComponent, HelpTeamMembersComponent, HelpPlaceholderComponent, QuestionnaireComponent],
    imports: [BrowserModule, FormsModule, RouterModule, PagingModule, ValidationModule, B2BAngularMaterialModule, CategoryTreeViewModule,
        BlockUIModule, TenderTeamMemberModule, MyDatePickerModule, TermsAndConditionsModalModule]
})

export class AccountManagementModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/account.management.module.ts